const Resources = {

    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Utilities",
            href: "/recycle-bin",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Recycle Bin",
            href: "/recycle-bin",
            arrow: "",
        },
    ],

    table_headers: [
        {
            text:   "Item name",
            align:  "start",
            value:  "name",
            type:   "text_bold"
        },
        {
            text:   "Module deleted from",
            value:  "module_name",
        },
        {
            text:   "Deleted on",
            value:  "deleted_at",
        },
        {
            text:   "Deleted by",
            value:  "user",
        },
        {
            text:   "Automatically deleted in",
            value:  "remaining_days",
        },
    ],

    system_list: [
        {
            name: 'All deleted items',
            identify: 'all',
        },
        // {
        //     name: 'Facility',
        //     identify: 'facility',
        // },
        {
            name: 'Buildings',
            identify: 'buildings',
        },
        {
            name: 'Associates',
            identify: 'associates',
        },
        {
            name: 'Assignments',
            identify: 'assignments',
        },
        {
            name: 'Budgeting',
            identify: 'budgeting',
        },
        {
            name: 'Census',
            identify: 'census',
        },
        {
            name: 'Days Off',
            identify: 'daysoff',
        },
        {
            name: 'QC',
            identify: 'qc',
        },
        {
            name: 'Options',
            identify: 'options',
        },
        {
            name: 'Reports',
            identify: 'reports',
        },
    ],
};

export default Resources;